<div *ngIf="showReminder" class="backdrop">
  <div class="modal">
    <h2>You're about to be logged out</h2>
    <p>Your current session does not seem to be active.</p>
    <p>You'll be logged out in</p>
    <p [style.color]="countdownColor">{{ formatCountdown(countdown) }}</p>
  </div>
</div>
